module.exports = __webpack_public_path__ + "static/Yantramanav-ef2d31ead84495c3afecba6847adfdce.ttf";